import { HttpClient } from 'api/http-client';
import { HolidayCalendar, HolidayCalendarPayload } from './types';

class HolidayCalendarHttpClient extends HttpClient {
  public getHolidayCalendars(): Promise<Array<HolidayCalendar>> {
    return this.get('/holiday-calendar');
  }

  public getHolidayCalendar(calendarId: number): Promise<HolidayCalendar> {
    return this.get(`/holiday-calendar/${calendarId}`);
  }

  public createHolidayCalendar(
    holidayCalendar: HolidayCalendarPayload,
  ): Promise<HolidayCalendar> {
    return this.post('/holiday-calendar', holidayCalendar);
  }

  public editHolidayCalendar(
    holidayCalendar: HolidayCalendar,
  ): Promise<HolidayCalendar> {
    return this.put('/holiday-calendar', holidayCalendar);
  }

  public deleteHolidayCalendar(calendarId: number): Promise<HolidayCalendar> {
    return this.delete(`/holiday-calendar/${calendarId}`);
  }
}

export const HolidayCalendarAPI = new HolidayCalendarHttpClient();
